import React, { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, Divider, Typography } from "antd";
import { request } from "../../functions/request";
import Aguarde from "../../components/aguarde/aguarde";
import { AiOutlineSearch, AiFillEdit, AiFillDelete } from "react-icons/ai";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { Content } from "antd/es/layout/layout";
import { FaPlus } from "react-icons/fa";
import ModalAddAtalho from "../../components/Modal/Atalho/ModalAddAtalho";

const Atalhos = () => {
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState({});
  const [haveResult, setHaveResult] = useState(false);
  const [tableData, setTableData] = useState([]);

  const fetchTableData = async () => {
    try {
      const response = await request("/atalho/getAllAtalhos", {
        method: "GET",
      });
      setTableData(response);
      setHaveResult(true);
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  useEffect(() => {
    fetchTableData();
  }, []);

  const deleteAtalho = async (atl_codigo) => {
    try {
      await request(`/atalho/deleteAtalho/${atl_codigo}`, {
        method: "DELETE",
      });
      toast.success("Atalho excluído com sucesso!");
      fetchTableData();
    } catch (error) {
      console.log(error);
      toast.error("Erro ao excluir atalho!");
    }
  };

  const confirmDelete = (row) => {
    confirmAlert({
      title: "Você tem certeza que deseja excluir esse atalho?",
      message: "Essa ação será irreversível.",
      buttons: [
        { label: "Não", className: "button-delete", onClick: () => {} },
        {
          label: "Sim",
          className: "button-save",
          onClick: () => deleteAtalho(row.original.atl_codigo),
        },
      ],
    });
  };

  const columns = useMemo(
    () => [
      { accessorKey: "atl_codigo", header: "Id", size: 10 },
      {
        accessorKey: "atl_atalho",
        header: "Atalho",
        size: 150,
        Cell: ({ cell }) => `/${cell.getValue()}`,
      },
      {
        accessorKey: "atl_ativo",
        header: "Ativo",
        size: 50,
        Cell: ({ cell }) =>
          cell.getValue() ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled color="info" fontSize="small" className="active-icon" />
              Ativo
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                style={{ color: "var( --gray-color)" }}
              />
              Inativo
            </div>
          ),
      },
    ],
    []
  );

  return (
    <>
      <ModalAddAtalho
        isOpen={isAddOpen}
        editData={editOpen}
        onClose={() => setIsAddOpen(false)}
        onSaved={fetchTableData}
      />
      {haveResult ? (
        tableData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={tableData}
            defaultColumn={{ minSize: 5, maxSize: 200, size: 100 }}
            enableColumnFilterModes
            enableColumnSorting
            enableRowActions
            localization={MRT_Localization_PT_BR}
            positionActionsColumn="last"
            enableRowVirtualization
            enableFacetedValues
            columnFilterModeOptions={null}
            initialState={{
              showColumnFilters: true,
              pagination: { pageIndex: 0, pageSize: 100 },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "", size: 100 },
            }}
            renderRowActions={({ row }) => (
              <div style={{ display: "flex", gap: "5px", justifyContent: "end" }}>
                <Button
                  onClick={() => {
                    setEditOpen(row.original);
                    setIsAddOpen(true);
                  }}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillEdit />
                  Editar
                </Button>
                <Button
                  danger
                  onClick={() => confirmDelete(row)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillDelete />
                  Excluir
                </Button>
              </div>
            )}
            renderTopToolbarCustomActions={() => (
              <Content style={{ display: "flex", alignItems: "center", gap: 20, padding: 10 }}>
                <Typography.Title
                  level={4}
                  style={{ margin: 0, display: "flex", gap: 5, alignItems: "center" }}
                >
                  Atalhos de Texto
                </Typography.Title>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  icon={<FaPlus />}
                  size="large"
                  onClick={() => {
                    setEditOpen({});
                    setIsAddOpen(true);
                  }}
                >
                  Adicionar Atalho
                </Button>
              </Content>
            )}
            muiTableHeadCellFilterTextFieldProps={{ placeholder: "Filtrar" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "80%",
            }}
          >
            <Content style={{ display: "flex", justifyContent: "flex-end", padding: 10 }}>
              <Button
                type="primary"
                icon={<FaPlus />}
                size="large"
                onClick={() => {
                  setEditOpen({});
                  setIsAddOpen(true);
                }}
              >
                Adicionar Atalho
              </Button>
            </Content>
            <h2>Nenhum atalho cadastrado ainda.</h2>
            <AiOutlineSearch size={48} color="#888" />
          </div>
        )
      ) : (
        <Aguarde />
      )}
    </>
  );
};

export default Atalhos;
